import { ContactUsMain } from 'sections/contact-us'

export default function ContactUsPage() {
  return <ContactUsMain />
}
